import { render } from "./InvoiceId.vue?vue&type=template&id=ecdb5060&scoped=true&ts=true"
import script from "./InvoiceId.vue?vue&type=script&lang=ts"
export * from "./InvoiceId.vue?vue&type=script&lang=ts"

import "./InvoiceId.vue?vue&type=style&index=0&id=ecdb5060&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecdb5060"]])

export default __exports__